import { useSuspenseQuery } from "@tanstack/react-query";
import type { RecentJobView } from "@/components/recently_viewed_jobs/table";

const useRecentlyViewedJobs = ({ mock }: { mock?: boolean } = {}) => {
  if (mock) {
    return { data: [] };
  }
  const fetchRecentlyViewedJobs = async (): Promise<RecentJobView[]> => {
    const response = await fetch("/recently_viewed_jobs/dashboard");
    return response.json();
  };

  return useSuspenseQuery({
    queryKey: ["recentlyViewedJobs", "dashboard"],
    queryFn: fetchRecentlyViewedJobs,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useRecentlyViewedJobs;
